module.exports = __webpack_public_path__ + "img/Northern Ireland.59a55406.svg";